import PopupTopStrip from '../PopupTopStrip/PopupTopStrip';
import SelectSizeTable from '../SelectSizeTable/SelectSizeTable';
import { PopupContainer, SizeImage } from './styled';
import { useEffect, useState } from 'react';
import AddSizeToCart from '../AddSizeToCart';
import { viewedSizePopup } from '../instrumentation';

export default function MaternitySizePopup(props) {
  const {
    closePopup,
    selectedProduct,
    data,
    setAddedToCart,
    eventsData,
    productName,
  } = props;
  const [productSelected, setProductSelected] = useState(null);
  const [activeSize, setActiveSize] = useState(null);
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    let product_name;
    data.map((itemSet) => {
      itemSet.items.map((item) => {
        if (item._id == selectedProduct) {
          setProductSelected(item);
          product_name = item.name;
        }
      });
    });
    let url = window.location.pathname;
    viewedSizePopup(
      product_name?.substring(0, 99),
      selectedProduct,
      url?.substring(0, 99),
    );
  }, []);
  return (
    <>
      <PopupContainer>
        <PopupTopStrip closePopup={closePopup} />
        <div>
          {productSelected?.sizeChartImagesArr[0] && (
            <SizeImage src={productSelected?.sizeChartImagesArr[0]}></SizeImage>
          )}
        </div>
        <SelectSizeTable
          activeSize={activeSize}
          setActiveSize={setActiveSize}
          sizeData={productSelected?.sizeVariants}
          setDisabled={setDisabled}
          productId={activeSize}
          productName={productName}
        />
        <AddSizeToCart
          setAddedToCart={setAddedToCart}
          productId={activeSize}
          disabled={disabled}
          setDisabled={setDisabled}
          eventsData={eventsData}
          cardName={productSelected?.print}
        ></AddSizeToCart>
      </PopupContainer>
    </>
  );
}
